import { IReCaptchaComposition } from 'vue-recaptcha-v3';

export default class RecaptchaService {
  private static recaptchaInstance: IReCaptchaComposition | null = null;

  public static initialize(instance: IReCaptchaComposition): void {
    this.recaptchaInstance = instance;
  }

  public static async getToken(action: string): Promise<string> {
    try {
      if (!this.recaptchaInstance) {
        console.warn('reCAPTCHA not initialized.');
        return '';
      }

      const { executeRecaptcha, recaptchaLoaded } = this.recaptchaInstance;
      await recaptchaLoaded();
      return await executeRecaptcha(action);
    } catch (error) {
      console.error('reCAPTCHA execution failed:', error);
      return '';
    }
  }
}
